export default "__VITE_ASSET__B$oDkSeQ__"